import { declareVueComponent } from '/vodalys/vvuejs/vueRegister.mjs'

import chartjs from '/vodalys/vlib/js/chart.4.4.8.js';

import TroubleshootingBandwith from './TroubleshootingBandwith.vue'
declareVueComponent('troubleshootingBandwith', TroubleshootingBandwith);

import TroubleshootingBandwithDownload from './TroubleshootingBandwithDownload.vue'
declareVueComponent('troubleshootingBandwithDownload', TroubleshootingBandwithDownload); 

import TroubleshootingBandwithUpload from './TroubleshootingBandwithUpload.vue'
declareVueComponent('troubleshootingBandwithUpload', TroubleshootingBandwithUpload); 

import TroubleshootingBandwithLatency from './TroubleshootingBandwithLatency.vue'
declareVueComponent('troubleshootingBandwithLatency', TroubleshootingBandwithLatency); 